import { Helmet } from "react-helmet-async";

const SeoHead = ({
    metadata,
    schemas = [],
    noIndex = false,
    ogType = "website",
}) => {
    const robotsContent =
        noIndex
            ? "noindex,nofollow"
            : "index,follow";
    return (
        <Helmet prioritizeSeoTags>
            {/* Primary */}
            <title>{metadata.title}</title>

            <meta
                name="description"
                content={metadata.description}
            />

            {/* Favicon */}
            <link
                rel="icon"
                type="image/png"
                sizes="48x48"
                href="/favicon-48.png"
            />

            <link
                rel="apple-touch-icon"
                sizes="180x180"
                href="/apple-touch-icon.png"
            />

            {/* Robots */}
            <meta
                name="robots"
                content={robotsContent}
            />

            {/* Canonical */}
            <link
                rel="canonical"
                href={metadata.canonicalUrl}
            />

            {/* Open Graph */}
            <meta
                property="og:type"
                content={ogType}
            />

            <meta
                property="og:site_name"
                content="UpNComer"
            />

            <meta
                property="og:title"
                content={metadata.title}
            />

            <meta
                property="og:description"
                content={metadata.description}
            />

            <meta
                property="og:image"
                content={metadata.image}
            />

            <meta
                property="og:image:width"
                content="1200"
            />

            <meta
                property="og:image:height"
                content="630"
            />

            <meta
                property="og:url"
                content={metadata.canonicalUrl}
            />

            {/* Twitter */}
            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:site"
                content="@upncomer"
            />

            <meta
                name="twitter:title"
                content={metadata.title}
            />

            <meta
                name="twitter:description"
                content={metadata.description}
            />

            <meta
                name="twitter:image"
                content={metadata.image}
            />

            {/* JSON-LD */}
            {schemas && (!Array.isArray(schemas) || schemas.length > 0) && (
                <script type="application/ld+json">
                    {JSON.stringify(schemas)}
                </script>
            )}
        </Helmet>
    );
};

export default SeoHead;